import { combineReducers } from "redux";
import authReducer from "./authReducer";
import userReducer from "./userReducer";
import twoFASetupReducer from "./twoFASetupReducer";
import walletReducer from "./walletReducer";
import transactionReducer from "./transactionsReducer";
import supportFAQReducer from "./faqReducer";
import adminUsersReducer from "./adminUsersReducer";
import adminTransactionsReducer from "./adminTransactionsReducer";
import adminWalletReducer from "./adminWalletReducer";
import adminDashboardStatsReducer from "./adminDashboardStatsReducer";
import adminAuthReducer from "./adminAuthReducer";
import adminProfileReducer from "./adminProfileReducer";

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  twoFASetup: twoFASetupReducer,
  wallet: walletReducer,
  transaction: transactionReducer,
  faq: supportFAQReducer,
  adminUser: adminUsersReducer,
  adminTransaction: adminTransactionsReducer,
  adminWallet: adminWalletReducer,
  adminDashboardStats: adminDashboardStatsReducer,
  adminAuth: adminAuthReducer,
  adminProfile: adminProfileReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "RESET_ALL_STATE") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
